import * as z from "zod";

export const formSchema = z.object({
  // General Info
  centerName: z.string().min(2, "Il nome del centro è obbligatorio"),
  ownerName: z.string().min(2, "Il nome del titolare è obbligatorio"),
  phoneNumber: z.string().min(10, "Inserisci un numero valido"),
  email: z.string().email("Inserisci un'email valida"),
  address: z.string().min(5, "L'indirizzo è obbligatorio"),
  city: z.string().min(2, "La città è obbligatoria"),
  province: z.string().min(2, "La provincia è obbligatoria"),
  zipCode: z.string().min(5, "Il CAP è obbligatorio"),
  googleMapsLink: z.string().optional(),
  website: z.string().optional(),
  landmarks: z.string().optional(),

  // Accessi Facebook
  facebookEmail: z.string().email("Inserisci un'email valida"),
  facebookPassword: z.string().min(1, "La password è obbligatoria"),

  // Business
  employeeCount: z.string().min(1, "Indica il numero di dipendenti"),
  cabinCount: z.string().min(1, "Indica il numero di cabine"),
  yearsInBusiness: z.enum(["under_1", "1_to_3", "3_to_7", "over_7"], {
    required_error: "Seleziona da quanti anni è aperto il centro",
  }),
  centerZone: z.enum(["city_center", "semi_center", "suburb", "small_town"], {
    required_error: "Seleziona la zona del centro",
  }),
  clientsLast12Months: z.enum(["under_200", "200_500", "500_1000", "1000_2000", "over_2000"], {
    required_error: "Seleziona un'opzione",
  }),
  databaseSize: z.enum(["under_500", "500_1000", "1000_2000", "2000_5000", "over_5000", "paper_only"], {
    required_error: "Seleziona un'opzione",
  }),
  salesResponsible: z.array(z.string()).min(1, "Seleziona almeno un'opzione"),
  sellsPathsOrCards: z.enum(["paths", "cards", "both"], {
    required_error: "Seleziona un'opzione",
  }),
  hasFinancing: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  financingProviders: z.array(z.string()).optional(),
  hasProprietaryMethod: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  proprietaryMethodName: z.string().optional(),
  centerSpecialization: z.enum(["basic", "face", "body", "advanced", "epilation_laser"], {
    required_error: "Seleziona la specializzazione",
  }),
  specializedCompetitors: z.string().min(2, "Indica almeno un competitor"),
  pricePositioning: z.enum(["cheaper", "same", "premium"], {
    required_error: "Seleziona il posizionamento",
  }),
  parkingEase: z.enum(["very_easy", "easy", "neutral", "difficult", "very_difficult"], {
    required_error: "Seleziona un'opzione",
  }),
  socialAdsExperience: z.enum(["yes", "first_time"], {
    required_error: "Seleziona un'opzione",
  }),
  marketingAgencyExperience: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),

  // Numeri, Obiettivi & Staff (nuovo step)
  monthlyRevenueAvg: z.string().min(1, "Indica il fatturato mensile medio"),
  doesBasicAesthetics: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  revenueSplitBasicVsAdvanced: z
    .string()
    .min(3, "Indica la ripartizione tra estetica di base e avanzata"),
  revenueSplitAdvancedTreatments: z
    .string()
    .min(3, "Indica la ripartizione tra viso, laser e corpo"),
  monthlyProfitAvg: z.string().min(1, "Indica l'utile medio mensile"),
  ownerSalaryConsistency: z.string().min(1, "Rispondi alla domanda"),
  revenueSplitNewVsReturning: z
    .string()
    .min(3, "Indica la ripartizione tra nuovi e vecchi clienti"),
  internalMarketingActions: z
    .string()
    .min(10, "Descrivi le azioni di marketing interno"),
  otherActionsForGoals: z
    .string()
    .min(10, "Descrivi le azioni pianificate"),
  goalWithSaloneVincente: z
    .string()
    .min(10, "Descrivi il tuo obiettivo con Salone Vincente"),
  whyThisGoal: z
    .string()
    .min(10, "Spiega il motivo di questo obiettivo"),
  staffStructure: z
    .string()
    .min(5, "Descrivi la struttura del centro"),
  staffRelationship: z
    .string()
    .min(10, "Descrivi il rapporto con lo staff"),
  ownerOperationalRole: z
    .string()
    .min(5, "Rispondi alla domanda"),

  // Treatments
  mainTreatment: z.string().min(10, "Descrivi il trattamento principale"),
  treatmentReason: z.string().min(10, "Spiega il motivo della promozione"),
  differentiators: z.string().min(10, "Descrivi cosa ti differenzia"),
  shortTermResults: z.string().min(10, "Descrivi i risultati a breve termine"),
  longTermResults: z.string().optional(),
  recommendations: z.string().optional(),
  sessionDuration: z.string().optional(),

  // Clientele
  openingHours: z.string().min(5, "Indica gli orari di apertura"),
  clientRadius: z.string().min(1, "Indica il raggio d'azione"),

  // Communication
  appearInAds: z.string().min(2, "Specifica la tua disponibilità"),
  voiceInAds: z.string().optional(),
});
